import { Accordion, AccordionDetails, AccordionSummary, Paper, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { useEffect, useState } from 'react'
import { ActiveOrdersTiles } from '../components/common/ActiveOrdersTiles'
import { FileImportDialog } from '../components/dialogs/FileImportDialog'
import { MassOrderInputDialog } from '../components/dialogs/MassOrderInputDialog'
import { OrderDisplay } from '../components/OrderList/OrderDisplay'
import { OrderTableTopBar } from '../components/OrderList/OrderTableTopBar'
import { useInstrumentApi } from '../hooks/useInstrumentApi'
import { useTranslation } from 'react-i18next'
import { initializeSseOrder } from '../hooks/useOrderSseApi'
import { useSelector } from '../redux/hooks/useSelector'
import { OrdersByStateCount } from '../redux/reducers/orders'
import { useDispatch } from 'react-redux'
import { ExpandMore } from '@mui/icons-material'
import useMobileWidth from '../hooks/useMobileWidth'
import { newThemeObject } from '../newTheme'
import { NewLayout } from '../components/newLayout/NewLayout'
import { AlertMessageConfirmation } from '../components/dialogs/AlertMessageConfirmation'
import { useOrderFilters } from '../hooks/useOrderFilters'
import { newTraderDiary } from '../constants/initialStates'

const useStyles = makeStyles(theme => ({
  orderDisplayTable: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(2),
    marginRight: theme.spacing(6),
    flexGrow: 1,
  },
  clientEssentials: {
    width: '25%',
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
  },
  manIcon: {
    marginTop: theme.spacing(1),
  },
  clientPersonalInfoColumn: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1),
  },
  test: {
    background: 'red',
    width: '200px',
    position: 'absolute',
    top: '20px',
    left: '-50px',
    opacity: '0.95',
    textAlign: 'center',
    lineHeight: '25px',
    fontSize: '16px',
    letterSpacing: '1px',
    color: '#f0f0f0',
    transform: 'rotate(-45deg)',
    paddingRight: '18px',
  },

  searchBar: {
    background: newThemeObject.palette.orderTable.searchBar.bg,
    padding: 0,
    borderRadius: '15px',
    margin: '20px 0',
    borderTop: 0,
    '&.Mui-expanded': {
      margin: '20px 0',
    },
    '&::before': {
      display: 'none',
    },
  },
  searchBarHeadText: {
    margin: 0,
    padding: 0,
  },
  searchBarHead: {
    padding: 0,
    margin: 0,
    dispay: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  accDetail: {
    padding: theme.spacing(2),
  },
}))

const ribon = process.env.REACT_APP_ENV_RIBBON

export const OrderList = () => {
  const classes = useStyles()
  const { getOrderTableRows, updateOrderDiary, exportOrderDiary } = useInstrumentApi()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isMobile = useMobileWidth()
  const [filtersExpanded, setFiltersExpanded] = useState(isMobile)
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [orderToExport, setOrderToExport] = useState<number[]>([]);

  const [dateFrom, setDateFrom] = useState<Date>(new Date())
  const [dateTo, setDateTo] = useState<Date>(new Date())

  useEffect(() => {
    initializeSseOrder(dispatch, null, dateFrom, dateTo)
  }, [dateFrom, dateTo])

  const [ordersByStateCount, setOrdersByStateCount] = useState([] as OrdersByStateCount[])
  const orderSse = useSelector(state => state.orders.orderSse)
  const orderTableRows = useOrderFilters();

  useEffect(() => {
    if (orderSse && orderSse.userStates && orderSse.userStates.length > 0) {
      setOrdersByStateCount([...orderSse.userStates[0].states])
    }
  }, [orderSse])

  useEffect(() => {
    isMobile ? setFiltersExpanded(false) : setFiltersExpanded(true)
  }, [isMobile])

  useEffect(() => {
    getOrderTableRows(null, null, null, null)
  }, [])

  const handleChange = () => {
    setFiltersExpanded(!filtersExpanded)
  }

  const setOrderCheckInner = (orderId: number, valueDiary: boolean) => {
    updateOrderDiary(orderId, !valueDiary);
  }

  const setShowConfirmationDialog = (open: boolean) => {
    let tmp = [];
    for ( let i=0; i<orderTableRows.length; i++) {
      tmp.push(orderTableRows[i].orderId);
    }
    setOrderToExport(tmp)
    setShowConfirmation(open);
  }

  const handleConfirmation = () => {
    setShowConfirmation(false);
    exportOrderDiary(orderToExport);
    setOrderToExport([]);
  }

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    setOrderToExport([]);
  }

  return (
    <NewLayout pageName={t('ORDER_OVERVIEW')}>
      <ActiveOrdersTiles ordersByStateCount={ordersByStateCount} />
      <Accordion elevation={0} className={classes.searchBar} expanded={filtersExpanded} onChange={handleChange}>
        <AccordionSummary expandIcon={<ExpandMore />} className={classes.searchBarHead}>
          <p className={classes.searchBarHeadText}>Filtry</p>
        </AccordionSummary>
        <AccordionDetails className={classes.accDetail}>
          <OrderTableTopBar
              dateFrom={dateFrom}
              setDateFrom={setDateFrom}
              dateTo={dateTo}
              setDateTo={setDateTo}
              setShowConfirmation={setShowConfirmationDialog}
          />
        </AccordionDetails>
      </Accordion>
      <OrderDisplay
        setOrderCheck={setOrderCheckInner}
      />
      <MassOrderInputDialog traderDiary={newTraderDiary} isFromTrader={false}/>
      <FileImportDialog />
      <AlertMessageConfirmation
        alertOpen={showConfirmation}
        onOk={handleConfirmation}
        onCancle={handleCloseConfirmation}
        alertText={t('INVESTMENT_DIARY_MESSAGE')}
      />
      
    </NewLayout>
  )
}
